// The card never outgrows its column; on phones its heading wraps and grows.
const WizardContent = (props: any) => {
  return (
    <div className="w-[745px] max-w-full min-h-[452px] h-auto mt-4 bg-white rounded-lg shadow-md inset-0">
      <div className="w-[743px] max-w-full h-[70px] max-sm:h-auto max-sm:min-h-[70px] max-sm:px-4 max-sm:py-2 bg-blueGreen mb-10 rounded-t-lg text-white text-2xl max-sm:text-xl font-bold flex items-center justify-center max-sm:text-center">
        {props.heading}
      </div>
      {props.children}
    </div>
  );
};

export default WizardContent;
